<template>
  <div class="content">
    <div class="section-header" @click="showSupportDeskInfo = !showSupportDeskInfo">
      <div class="section-titles">
        <h1 class="title">{{ $t('support-desk-information-0') }}</h1>
        <h4 class="subtitle">For technical questions or issues.</h4>
      </div>
      <Carrot :class="showSupportDeskInfo ? 'carrot-flipped' : 'carrot'" />
    </div>
    <div v-if="showSupportDeskInfo" class="flex-column support-desk-info">
      <div class="flex-row row-1">
        <div class="section">
          <h4 class="section-title">INCENTIVE DASHBOARD TECHNICAL ASSISTANCE:</h4>
          <span v-if="programName === 'US CED'">CED Help Desk: <br /></span>
          <span v-if="programName === 'US CF' || programName === 'PR CF'">Customer First Help Desk: <br /></span>
          <span v-if="programName === 'US ALFA'">Alfa Romeo Premium Experience Program Help Desk: <br /></span>
          <span v-if="programName === 'US Wgnr'">Wagoneer Help Desk: <br /></span>
          <span v-if="programName === 'US EVR'">LEV Readiness Help Desk: <br /></span>
          <ul>
            <li class="link">stellantis-customerfirst@track360.com</li>
          </ul>
          <span
            >For dashboard dial results and data support, please contact your Business Center/Field
            Representative.</span
          >
        </div>
        <div class="section" v-if="programName === 'US CF' || programName === 'PR CF' || programName === 'US Wgnr'">
          <h4 class="section-title">{{ $t('training-certifications') }}</h4>
          <span>Performance Institute Help Desk:</span>
          <ul>
            <li class="link">(888) 321-4321</li>
          </ul>
        </div>
      </div>
      <div class="flex-row row-2">
        <div class="section" v-if="programName !== 'US Wgnr'">
          <h4 class="section-title">{{ $t('cx-surveys') }}</h4>
          <span>CX Dashboard Help Desk:</span>
          <ul>
            <li class="link">(800) 866-1774</li>
          </ul>
          <h4 class="section-title os-vdc">OS+ / VDC RESULTS:</h4>
          <span>Visit: <a class="link">rewardingexcellence.com</a></span>
        </div>
        <div class="section">
          <h4 class="section-title">{{ $t('for-all-other-questions') }}</h4>
          <span>DealerCONNECT Help Desk:</span>
          <ul>
            <li class="link">(800) 374-4040</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="open-legend flex-column">
      <div class="section-header" @click="showLegend = !showLegend">
        <h1 class="title">{{ $t('colors') }} {{ $t('and-icon-legend') }}</h1>
        <Carrot :class="showLegend ? 'carrot-flipped' : 'carrot'" />
      </div>
      <div class="flex-column" v-if="showLegend">
        <h4 class="section-label">color legend:</h4>
        <div class="flex-row legend-columns">
          <div class="flex-column">
            <div :class="['tabs', item.color]" v-for="item in legend.columnOne" :key="item.color">
              <span>{{ $t(item.text) }}</span>
            </div>
          </div>
          <div class="flex-column">
            <div :class="['tabs', item.color]" v-for="item in legend.columnTwo" :key="item.color">
              <span>{{ $t(item.text) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carrot from '@/assets/icons/carrot_up.svg';
import { mapState } from 'vuex';
import legend from '@/utils/legend';

export default {
  name: 'HelpComponent',
  components: { Carrot },
  data() {
    return {
      legend: legend(),
      showSupportDeskInfo: true,
      showLegend: true,
    };
  },
  methods: {},
  computed: {
    ...mapState('global', ['programName']),
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 40px;
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
}
.section-header {
  display: flex;
  align-items: center;
  font-size: 18px;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  background-color: #dfe4e8;
  padding: 30px;
  margin: -30px -30px 0px;
}
.title {
  font-size: 18px;
  line-height: 24px;
  text-transform: uppercase;
  font-weight: bold;
}
.subtitle {
  font-size: 14px;
  line-height: 20px;
  opacity: 0.5;
  text-transform: none;
  margin: 10px 0px 0px;
}
.support-desk-info {
  padding: 30px 0px 35px;
  .row-1 {
    margin-bottom: 30px;
  }
  .section {
    padding: 20px;
    margin-right: 30px;
    border: 1px solid $input-readonly;
    width: 500px;
    font-size: 14px;
    line-height: 20px;
    .section-title {
      font-size: 15px;
      line-height: 21px;
      font-weight: bold;
      margin: 0px 0px 15px;
    }
    .os-vdc {
      margin-top: 25px;
    }
    ul {
      padding-left: 15px;
      margin: 5px 0px;
    }
  }
}
.flex-grid {
  display: flex;
  flex-direction: row;
  height: 240px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.legend-columns .flex-column {
  margin-right: 150px;
}
.open-legend {
  text-align: left;
  color: black;
  width: 100% !important;
  padding-top: 20px;
  .section-label {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    padding: 30px 0px;
    margin: 0px;
  }
}
.dial-column {
  width: 500px;
}
.dials {
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  span {
    display: flex;
    align-items: center;
  }
  &::before {
    border-radius: 50px;
    font-size: 14px;
    height: 15px;
    width: 15px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    content: '';
    align-items: center;
  }
}
.gray {
  &::before {
    border: 8px solid #8a8c8d;
  }
}
.black {
  &::before {
    border: 8px solid #000000;
  }
}
.orange {
  &::before {
    border: 8px solid $fca-orange;
  }
}
.green {
  &::before {
    border: 8px solid #038717;
  }
}
.red {
  &::before {
    border: 8px solid #eb0001;
  }
}
.light-gray {
  &::before {
    border: 8px solid #c4c5c6;
  }
}
.blue {
  &::before {
    border: 8px solid #597dd9;
  }
}
.yellow {
  &::before {
    border: 8px solid #e4bd35;
  }
}
.dark-blue {
  &::before {
    border: 8px solid #6d20be;
  }
}
.light-red {
  &::before {
    border: 8px solid #ff6261;
  }
}
.pillars {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.Performance {
  svg {
    min-width: 30px !important;
    height: 30px !important;
    padding: 0;
    margin-left: -5px;
    filter: drop-shadow(0px 3px 6px #00000029);
    &.gray {
      g {
        circle {
          fill: #898c8d;
        }
      }
    }
    &.green {
      g {
        circle {
          fill: #008716;
        }
      }
    }
    &.red {
      g {
        circle {
          fill: #ec0000;
        }
      }
    }
  }
}
.tabs {
  display: flex;
  margin-bottom: 10px;
  span {
    display: flex;
    align-items: center;
  }
  &::before {
    border-radius: 50px;
    font-size: 14px;
    height: 15px;
    width: 15px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    content: '';
    align-items: center;
  }
  &.gray {
    &::before {
      background: #8a8c8d;
    }
  }
  &.black {
    &::before {
      background: #000000;
    }
  }
  &.orange {
    &::before {
      background: $fca-orange;
    }
  }
  &.green {
    &::before {
      background: #038717;
    }
  }
  &.red {
    &::before {
      background: #eb0001;
    }
  }
  &.light-gray {
    &::before {
      background: #c4c5c6;
    }
  }
  &.blue {
    &::before {
      background: #597dd9;
    }
  }
  &.yellow {
    &::before {
      background: #e4bd35;
    }
  }
  &.dark-blue {
    &::before {
      background: #6d20be;
    }
  }
  &.light-red {
    &::before {
      background: #ff6261;
    }
  }
}
</style>
